import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Global offline/online toast notifications
window.addEventListener('offline', () => {
  const event = new CustomEvent('app:network', { detail: 'offline' });
  window.dispatchEvent(event);
});
window.addEventListener('online', () => {
  const event = new CustomEvent('app:network', { detail: 'online' });
  window.dispatchEvent(event);
});

// Auto-reload when service worker updates (prevents stale chunk 404s after deploy).
// Skip it on the very first install: there is no old version to replace, and the
// reload would just play the splash a second time.
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SW_UPDATED' && hadController) {
      window.location.reload();
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

